<template>
    <div class="pa-18px pa-md-24px">
        <v-row align="center" class="row--sm">
            <v-col cols="12" md="2">
                <v-select v-model="query['code']" :items="codes" v-bind="{ ...attrs, loading }" />
            </v-col>
            <v-col cols="12" md="5">
                <div class="d-flex flex-column flex-sm-row align-center">
                    <v-text-field v-model="query['createdAt'][0]" type="date" v-bind="{ ...attrs, loading }" class="w-100" />
                    <span class="txt txt--xs mx-8px">~</span>
                    <v-text-field v-model="query['createdAt'][1]" type="date" v-bind="{ ...attrs, loading }" class="w-100" />
                </div>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="query['searchValue']" placeholder="상품명을 검색하세요" append-icon="mdi-magnify" v-bind="{ ...attrs, loading }" @keydown.enter="search" @click:append="search" />
            </v-col>
            <v-col cols="12" md="1">
                <v-btn small block color="grey" v-bind="{ loading }" @click="search">조회</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { PURCHASE_QUERY_CODES } from "@/assets/variables";

const initQuery = (query = {}) => ({
    ["code"]: query["code"] || null,
    ["searchValue"]: query["searchValue"] || null,
    ["createdAt"]: JSON.parse(JSON.stringify(query["createdAt"] || [null, null])),
});

const codes = [{ text: "전체", value: null }].concat(Object.values(PURCHASE_QUERY_CODES));

const attrs = {
    outlined: true,
    dense: true,
    "hide-details": true,
};

export default {
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),
        codes,
        attrs,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        search() {
            let { ...query } = this.query;

            if (!query["code"]) delete query["code"];
            if (!query["searchValue"]) delete query["searchValue"];
            if (!query["createdAt"].some((item) => !!item)) delete query["createdAt"];
            delete query.page;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
